<template>
  <b-nav class="ml-4">
    <b-nav-item  v-if="isAdmin || isTrainingAdmin || isTrainingMod">
      <router-link :to="{ path: `/trainings` }">
        <b-button :class="this.$route.name == 'trainings' ? null : 'esep-blue-bg'" variant="primary">{{ $t("toolbar.manage") }}</b-button>
      </router-link>
    </b-nav-item>
    <b-nav-item v-if="isAdmin || isTrainingAdmin || isTrainingMod">
      <router-link :to="{ path: `/training/add` }">
        <template v-if="isAdmin || isTrainingAdmin">          
          <b-button :class="this.$route.name == 'trainingAdd' ? null : 'esep-blue-bg'" variant="primary">{{ $t("toolbar.add") }}</b-button>
        </template>
        <template v-else>
          <b-button :class="this.$route.name == 'trainingAdd' ? null : 'esep-blue-bg'" variant="primary">{{ $t("toolbar.propose") }}</b-button>
        </template>
      </router-link>
    </b-nav-item>

    <b-nav-item>
      <router-link :to="{ path: `/apply-activities/trainer/` + this.userInfo.id }">
        <b-button :class="this.$route.name == 'applyActivitiesTrainer' ? null : 'esep-blue-bg'" variant="primary">{{ $t("message.applyActivitiesTrainer") }}</b-button>
      </router-link>
    </b-nav-item>

    <b-nav-item v-if="isAdmin || isTrainingAdmin || isTrainingMod">
      <router-link :to="{ path: `/apply-activities/management` }">
        <b-button :class="this.$route.name == 'applyActivitiesManagement' ? null : 'esep-blue-bg'" variant="primary">{{ $t("message.applyActivitiesMgmt") }}</b-button>
      </router-link>
    </b-nav-item>

    <b-nav-item v-if="isAdmin || isTrainingAdmin">
      <router-link :to="{ path: `/leaders` }">
        <b-button :class="this.$route.name == 'trainingLeaders' ? null : 'esep-blue-bg'" variant="primary">{{ $t("toolbar.leaders") }}</b-button>
      </router-link>
    </b-nav-item>

    <b-nav-item v-if="isAdmin || isTrainingAdmin">
      <router-link :to="{ path: `/profile-batch` }">
        <b-button :class="this.$route.name == 'profileBatch' ? null : 'esep-blue-bg'" variant="primary">{{ $t("toolbar.profileBatch") }}</b-button>
      </router-link>
    </b-nav-item> 

    <b-nav-item v-if="isAdmin || isTrainingAdmin">
      <b-dropdown class="rounded" variant="primary" :text='$t("toolbar.parametrics")'>
        <router-link :to="{ path: `/parametrics/modules` }">
          <b-dropdown-item-button :active="this.$route.name == 'modules'">{{ $t('parametrics.modulesTitleShort')}}</b-dropdown-item-button>
        </router-link> 
        <router-link :to="{ path: `/parametrics/sessions` }">
          <b-dropdown-item-button :active="this.$route.name == 'sessions'">{{ $t('parametrics.sessionsTitleShort')}}</b-dropdown-item-button>
        </router-link> 
        <router-link :to="{ path: `/parametrics/criterias` }">
          <b-dropdown-item-button :active="this.$route.name == 'criterias'">{{ $t('parametrics.criteriasTitleShort')}}</b-dropdown-item-button>
        </router-link>
        <router-link :to="{ path: `/parametrics/announcements` }">
          <b-dropdown-item-button :active="this.$route.name == 'announcements'">{{ $t('parametrics.announcementsTitleShort')}}</b-dropdown-item-button>
        </router-link>
      </b-dropdown>
    </b-nav-item> 
  </b-nav>
</template>

<script>
import trainingService from "@/services/training.service";
import {makeErrorToast} from "@/services/error.service";

export default {
  mounted() {
    trainingService.getUserInfo(this.username).then(
        (response) => {
          this.userInfo = response.data;
          this.$store.state.userInfo = this.userInfo;
          this.fetchRoles();
        },
        (error) => {
          makeErrorToast(this.$bvToast, error);
        }
    );
  },
  data() {
    return {
      isAdmin: false,
      isTrainingAdmin: false,
      isTrainingMod: false,
      isUnitAdmin: false,
      userInfo: {}
    }
  },
  methods: {
    fetchRoles() {
      this.userInfo = this.$store.state.userInfo;
      for(var i=0; i< this.userInfo.roles.length; i++){
        if(this.userInfo.roles[i].name == "ADMIN" ) {
          this.isAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_ADMIN") {
          this.isTrainingAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAIN_MOD"){
          this.isTrainingMod = true;
        } else if(this.userInfo.roles[i].name == "UNIT_ADMIN"){
          this.isUnitAdmin = true;
        }
      }
    }
  }
};
</script>

<style>
.dropdown-toggle{
  background-color: #1565c0;
  border-color: #1565c0;
}

a:hover {
  text-decoration: none;
}
</style>